import { useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import { Loader } from 'src/components/LayoutComponents/Loader';
import { NewPassword } from 'src/pages/NewPassword';
import { RootState } from 'src/redux/store';
import { Location } from 'history';
import { PublicLayout } from './Public';
import { LoginLayout } from './Login';
import { MainLayout } from './Main';

type ContentProps = {
  location: Location;
  children: React.ReactNode;
};

const getLayout = (location: Location) => {
  if (location.pathname === '/') {
    return 'public';
  }
  if (/^\/user(?=\/|$)/i.test(location.pathname)) {
    return 'login';
  }
  return 'main';
};

const Layouts = {
  public: PublicLayout,
  login: LoginLayout,
  main: MainLayout,
};

export const Content: React.FC<ContentProps> = ({ children, location }) => {
  const user = useSelector((state: RootState) => state.user);
  const { authorized: isUserAuthorized, newPassword: isNewPassword, loading: isUserLoading } = user;

  const layout = getLayout(location);
  const Container = Layouts[layout];
  const isLoginLayout = layout === 'login';

  if (isUserLoading && !isUserAuthorized && !isLoginLayout) {
    return <Loader />;
  }
  if (!isLoginLayout && !isUserAuthorized) {
    return <Redirect to="/user/login" />;
  }
  if (isNewPassword) {
    return <NewPassword />;
  }
  if (isLoginLayout && isUserAuthorized) {
    return <Redirect to="/dashboard/wahed" />;
  }
  return <Container>{children}</Container>;
};
